
<template>
    <AppPermission :permission="this.$permissions.refunds.data?? '' ">
        <div class="container">
            <div class="row m-0 p-0">
                <div class="mainLeft pt-3">
                    <div class="main-title">
                        <span>
                            {{$t('message.headers.request_refund')}}
                        </span>
                    </div>
                    <div>
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row">
                                <div class="col-8 text-title">
                                    <label for="">{{$t('message.common.numberRecord')}}:</label>
                                </div>
                                <div class="col-4">
                                    <select :value="numberRecord" name="number_records" id="number_records" class="number_records" @change="onChange($event)">
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label for="" class="typeTitle">{{$t('message.common.branch')}}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('branchBody', 'branchDown', 'branchUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="branchDown"></i>
                                        <i class="fa fa-chevron-up" id="branchUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 pb-3 pt-0" id="branchBody">
                            <div class="row">
                                <div class="col-12">
                                    <q-select v-model="filterQuery.branchId" 
                                    :modelValue="filterQuery.branchId" 
                                    :default-options="this.branches.all" 
                                    :multiple="true" 
                                    :placeholder="$t('message.common.placeholder.branch')" 
                                    :isFilter="true"
                                    @update:modelValue="updateFilterBranch"
                                    class="border-bottom-1"/>
                                    <!-- <SelectSearch :placeholder="$t('message.common.placeholder.branch')" :modelValue="filterQuery.branchId" :defaultOption="this.branches.all" @update:modelValue="doFilterSearch" :label="'branchId'"/> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{$t('message.common.time')}}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('timeBody', 'timeDown', 'timeUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="timeDown"></i>
                                        <i class="fa fa-chevron-up" id="timeUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 py-2" id="timeBody">
                            <SelectDateTime :label="'time'" @update:modelValue="doFilterTime"/>
                        </div>
                    </div>

                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{$t('message.common.status')}}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('statusBody', 'statusDown', 'statusUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="statusDown"></i>
                                        <i class="fa fa-chevron-up" id="statusUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 pt-0 pb-2" id="statusBody">
                            <div class="row" v-for="status in this.listStatus" :key="status.id">
                                <div class="col-12 d-flex align-items-center">
                                    <label class="container-checkbox">{{status.name}}
                                        <input type="checkbox" class="chkType" @click="doFilter('status', status.id)" :checked="isExistInArrayChecked(status, this.filterQuery.status)">
                                        <span class="checkmark-checkbox"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{$t('message.common.created_by')}}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('creatorBody', 'creatorDown', 'creatorUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="creatorDown"></i>
                                        <i class="fa fa-chevron-up" id="creatorUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 pt-0 pb-3" id="creatorBody">
                            <div class="row">
                                <div class="col-12">
                                    <SelectSearch :placeholder="$t('message.PlanIndex.chooseCreatedBy')" :modelValue="filterQuery.createdBy" :defaultOption="this.createdBy.all" @update:modelValue="doFilterSearch" :label="'createdBy'"></SelectSearch>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- right -->
                <div class="mainRight">
                    <div class="sticky-top pt-3">
                        <div class="row">
                            <div class="col-lg-5">
                                <InputQuickSearch :placeholder="$t('message.common.searchInvoice')" @filterSearch="changeQuickSearch" :requestRefundSearch="true" />
                            </div>
                            <div class="col-lg-7 d-flex justify-content-end">
                                <button type="button" @click="clearFilter()" class="btn btn-default" >
                                    <i class="fa fa-filter mr-1"></i>
                                    {{$t('message.button.removeFilter')}}
                                </button>
                                <div class="dropdown" v-if="this.arrayChecked?.length > 0 && entries?.length > 0">
                                    <button class="btn btn-save dropdown-toggle mr-1" type="button" id="dropdownMenuButton"
                                        style="padding:7px" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-ellipsis-v px-2"></i>
                                        {{$t('message.button.action')}}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" @click="sendMailAndZalo()" v-if="this.statusEmail">
                                            <i class="fa fa-share"></i>
                                            {{ $t('message.button.sendMailText') }}
                                        </a>
                                        <a class="dropdown-item" @click="sendZalo()">
                                            <i class="fa fa-share"></i>
                                            {{ $t('message.PurchaseOrderIndex.button.sendZalo') }}
                                        </a>
                                    </div>
                                </div>
                                <AppPermission :permission="this.$permissions.refunds.create?? '' ">
                                    <button class="btn btn-save ml-1" @click.stop="createRefund()">
                                        <i class="fa fa-plus px-1"></i>
                                        {{ $t('message.InvoiceIndex.button.add') }}
                                    </button>
                                </AppPermission>
                                 <AppPermission :permission="this.$permissions.refunds.export?? '' ">
                                    <button class="btn btn-save ml-1" @click.stop="exportOverview()">
                                        <i class="fas fa-file-export px-1"></i>
                                        {{ $t('message.button.export.name') }}
                                    </button>
                                </AppPermission>
                            </div>
                        </div>
                        <div>
                            <Pagination :value="paginate" :record="this.numberRecord" @change="pageChange"/>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <div class="col-12" v-if="this.arrayChecked?.length > 0 && entries?.length > 0">
                                    {{ $t('message.common.numberRecordSelected', {number: this.arrayChecked?.length}) }}
                                    <a href="javascript:;" @click="removeChecked()"><i class="fa fa-times text-danger" aria-hidden="true"></i></a>
                                </div>
                                <div class="row mx-0 my-2" id="divTable">
                                    <table class="table table-index table-striped lstProduct" v-show="isShow()">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="checkbox-table" v-if="fields.length > 0"><input v-model="checkedAll" @change="onCheckedAll(checkedAll)" type="checkbox"/></th>
                                                <template v-for="field in fields" :key="field.field">
                                                    <th scope="col" v-if="field.selected" style="vertical-align: middle !important;">
                                                        <TableSortField :current="sortData.field" :no-sort="!field.isColumn" @onsort="sort"
                                                                        :class="field.class" :name="field.name" :field="field.field" :style="field.style" class="description"/>
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="entries.length > 0">
                                                <template v-for="(entry, index) in entries" :key="entry.id" >
                                                    <tr class="master-row" :style="index % 2 ? 'background-color: white' : null" :class="entry.id === this.requestRefundActive ? 'backgroup__detail border__master' :''" :id="'row_' + (index + 1)">
                                                        <td>
                                                            <input v-model="entry.checked" type="checkbox"  @change.stop="countChecked(entry.id)" class="prdChecked"
                                                                    :id="entry.id" :name="entry.name" :value="entry.code" :checked="isExistInArrayChecked(entry, this.arrayChecked)">
                                                        </td>
                                                        <template v-for="field in fields" :key="field.field">
                                                            <td class="ow-break-word py-0" v-if="field.selected" style="vertical-align:middle !important;" :style="'min-width:110px'" >
                                                                <a :href="'#row_' + index" class="description text-dark tagA" @click="detailRefund(entry.id, entry)">
                                                                    <div v-if="field.field === 'totalQuantityReceive'"  :style="field.style" class="description" :class="field.class">
                                                                        <template v-if="entry.return && entry.return.totalReturn">
                                                                            <span :class="entry.return.totalReturn == entry.totalRefund ? 'text-success' : 'text-danger'" v-text="entry.return.totalReturn"></span>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span class="text-danger">0</span>
                                                                        </template>
                                                                        <span v-text="'/' + (entry.totalRefund ? entry.totalRefund : 0)"></span>
                                                                    </div>
                                                                    <div v-else v-text="renderField(entry, field.field, field)" :title="renderField(entry, field.field, field)" :style="field.style" class="description" :class="field.class"></div>
                                                                </a>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                    <tr v-if="requestRefundActive === entry.id" :class="[ entry.id === requestRefundActive ? 'backgroup__detail border__header-detail' : '', errorClass]">
                                                        <td></td>
                                                        <td :colspan="fields.length" class="pb-0">
                                                            <div class="row detail-prd-row">
                                                                <div class="col-2 mt-2" @click="showContent('info')">
                                                                    <span :class="[ headerActive === 'info' ? 'backgroup__detail-active' : '', 'head-detail']">
                                                                        {{$t('message.ProductIndex.info')}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <!-- Chi tiết phiếu-->
                                                    <tr class="detail-row bg-white border__body-detail" v-if="requestRefundActive === entry.id">
                                                        <td></td>
                                                        <td :colspan="fields.length" class="border-top-0">
                                                            <div class="mt-2 pb-4 detail__user">
                                                                <div class="row mt-2 detail-prd-row">
                                                                    <div class="col-4">
                                                                        <div class="row border-bottom-1 mt-2 py-2">
                                                                            <div class="col-5">
                                                                                {{$t('message.common.requestRefundCode')}}:
                                                                            </div>
                                                                            <div class="col-7 ow-break-word">                                                            
                                                                                <b>{{ entry.code }}</b>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row border-bottom-1 mt-2 py-2">
                                                                            <div class="col-5 lableOS">
                                                                                {{$t('message.DeliveryIndex.created_at')}}:
                                                                            </div>
                                                                            <div class="col-7 ow-break-word lableOS pr-0">                                                            
                                                                                {{ dt(entry.createdAt) }}
                                                                            </div>
                                                                        </div>
                                                                        <div class="row border-bottom-1 mt-2 py-2">
                                                                            <div class="col-5">
                                                                                {{ $t('message.common.approveTime') }}:
                                                                            </div>
                                                                            <div class="col-7 ow-break-word">
                                                                                {{ dt(entry.approvalDate) }}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                    <div class="col-4">
                                                                        <div class="mx-1">
                                                                            <div class="col-12">
                                                                                <div class="row border-bottom-1 mt-2 py-2">
                                                                                    <div class="col-5">
                                                                                        {{$t('message.InputQuickSearch.title.code_invoice')}}:
                                                                                    </div>
                                                                                    <div class="col-7 ow-break-word">
                                                                                        <template v-if="entry.invoiceCode">
                                                                                            <a :href="'/invoices/index?code=' + entry.invoiceCode" target="_blank" class="text-decoration-none text-primary">{{ entry.invoiceCode }}</a>
                                                                                        </template>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row border-bottom-1 mt-2 py-2">
                                                                                    <div class="col-5">
                                                                                        {{$t('message.common.branch')}}:
                                                                                    </div>
                                                                                    <div class="col-7 ow-break-word">
                                                                                        {{ entry.branchName }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="row border-bottom-1 mt-2 py-2">
                                                                                    <div class="col-5 lableOS">
                                                                                        {{$t('message.common.status')}}:
                                                                                    </div>
                                                                                    <div class="col-7 ow-break-word">
                                                                                        <template v-if="entry.statusOrigin == this.$constant.refund_status_origin || (entry.statusOrigin == this.$constant.refund_approve && this.user && this.user.id == this.$constant.isAdmin)">
                                                                                            <SelectSearch :placeholder="$t('message.common.selectStatus')" :modelValue="this.statusEditId" :defaultOption="this.listStatus" :readonly="true" @update:modelValue="changeStatus" :label="'status_' + entry.id"/>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            {{ entry.status }}
                                                                                        </template>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-4" id="noteRO">  
                                                                        <div class="row p-0 font-italic">
                                                                            <div class="col-12">
                                                                                <div class="col-12" v-if="entry.statusOrigin == this.$constant.refund_status_origin || entry.statusOrigin == this.$constant.refund_approve">
                                                                                    <textarea v-model.trim="entry.description" :id="'note_'+ entry.id" :placeholder="$t('message.InvoiceIndex.note')" class="noteStyle px-4 text-gray font-italic"></textarea>
                                                                                    <i class="fa fa-pencil-alt text-gray" id="fa_edit"></i>
                                                                                </div>
                                                                                <div class="col-12 text-gray" v-else>
                                                                                    <i class="fa fa-pencil-alt text-gray" id="fa_edit"></i>
                                                                                    <span class="noteStyle px-4 text-gray font-italic">
                                                                                        {{ entry.description ? entry.description : $t('message.InvoiceIndex.note')}}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <!-- Chi tiet san pham va gia -->
                                                    <tr class="detail-row bg-white border__body-detail" v-if="requestRefundActive === entry.id">
                                                        <td :colspan="fields.length" class="border-top-0">
                                                            <div class="mt-2 pb-4 detail__user">
                                                                <div class="row mt-2 detail-prd-row detail-prd-table pl-2">
                                                                    <div class="col-12 pl-0">
                                                                        <table class="w-100">
                                                                            <thead>
                                                                                <tr class="backgroup__detail">
                                                                                    <template v-for="fieldDetail in this.fieldRefundDetail" :key="fieldDetail">
                                                                                        <th scope="col" class="pl-4"  v-text="fieldDetail.name" v-if="fieldDetail.selected" :style="fieldDetail.style ? fieldDetail.style : ''"></th>
                                                                                    </template>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr class="bg-white">
                                                                                    <th scope="col" class="pl-4"> 
                                                                                        <input type="text" v-model="this.defaultReturn.searchCode" @input="onInputFilterReturnDetail('searchCode')" :placeholder="$t('message.DetailOrdersCard.searchProductCode')" class="border-none bg-transparent h-100">
                                                                                    </th>
                                                                                    <th scope="col" class="pl-4"> 
                                                                                        <input type="text" v-model="this.defaultReturn.searchName" @input="onInputFilterReturnDetail('searchName')" :placeholder="$t('message.DetailOrdersCard.searchProductName')" class="border-none bg-transparent h-100">
                                                                                    </th>
                                                                                    <th scope="col" class="pl-4" :colspan="fieldRefundDetail.length - 2"> 
                                                                                    </th>
                                                                                </tr>
                                                                                <template v-if="this.defaultReturn.filter?.length > 0">
                                                                                    <template v-for="(detail, index) in this.defaultReturn.filter" :key="detail.id">
                                                                                        <template v-if="index >= (this.paginateDetail.currentPage - 1)*10 && index < this.paginateDetail.currentPage*10">
                                                                                            <tr :class="index % 2 ? 'bg-white' : 'bg-light'">
                                                                                                <td class="pl-4">
                                                                                                    <div class="row m-0 d-flex">
                                                                                                        <div class="col-1 p-0">
                                                                                                            <i class="fa fa-chevron-down" v-if="detail.children_combo && detail.children_combo.length > 0 && !detail.showCombo" @click="showCombo(detail)"></i>
                                                                                                            <i class="fa fa-chevron-up" v-if="detail.children_combo && detail.children_combo.length > 0 && detail.showCombo" @click="showCombo(detail)"></i>
                                                                                                        </div>
                                                                                                        <div class="col-10 p-0">
                                                                                                            <a :href="'/products/index?code=' + (detail.product.code)" target="_blank" class="text-decoration-none text-primary" v-if="detail.product && detail.product.code">{{detail.product.code}}</a>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td class="pl-4">
                                                                                                    <span v-text="detail.product ? detail.product.name : null"></span>
                                                                                                    <span class="description font-italic text-gray" v-text="detail.description" :title="detail.description"></span>
                                                                                                </td>
                                                                                                <td v-text="detail.product_unit && detail.product_unit?.unitName ? detail.product_unit?.unitName : null" class="text-center"></td>
                                                                                                <td v-text="detail.variant && detail.variant?.name ? detail.variant?.name : null" class="text-center"></td>
                                                                                                <td v-text="n(detail.quantity)" class="text-center"></td>
                                                                                                <td v-text="n(detail.price)" class="pl-4 text-right"></td>
                                                                                                <td v-text="n(detail.discountValue)" class="pl-4 text-right"></td>
                                                                                                <td v-text="n(detail.price - detail.discountValue)" class="pl-4 text-right"></td>
                                                                                                <td v-text="n(detail.subTotal)" class="pl-4 text-right"></td>
                                                                                            </tr>
                                                                                        </template>
                                                                                    </template>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <tr class="text-center bg-light">
                                                                                        <td :colspan="fieldRefundDetail.length">{{ $t('message.common.notFound') }}</td>
                                                                                    </tr>
                                                                                </template>
                                                                            </tbody>
                                                                        </table>
                                                                        <Pagination :value="paginateDetail" :record="10" v-if="this.paginateDetail.totalRecord >= 10"/>
                                                                    </div>
                                                                </div>
                                                                <div class="row detail-prd-row mt-4 pr-4">
                                                                    <div class="col-10 flex-end">{{$t('message.DetailOrdersCard.totalQuantity')}}:</div>
                                                                    <div class="col-2 flex-end" v-text="n(entry.totalQuantity)"></div>
                                                                </div>
                                                                <div class="row detail-prd-row mt-2 pr-4">
                                                                    <div class="col-10 flex-end">{{$t('message.DetailOrdersCard.total')}}:</div>
                                                                    <div class="col-2 flex-end" v-text="n(entry.totalOrigin)"></div>
                                                                </div>
                                                                <!-- <div class="row detail-prd-row mt-2 pr-4">
                                                                    <div class="col-10 flex-end">{{$t('message.InvoiceIndex.discount')}}:</div>
                                                                    <div class="col-2 flex-end" v-text="n(entry.discountValue)"></div>
                                                                </div> -->
                                                                <div class="row detail-prd-row mt-2 pr-4">
                                                                    <div class="col-10 flex-end">{{$t('message.ReturnIndex.returnCustomer')}}:</div>
                                                                    <div class="col-2 flex-end" v-text="n(entry.total)"></div>
                                                                </div>
                                                                <!-- <div class="row detail-prd-row mt-2 pr-4">
                                                                    <div class="col-10 flex-end">{{$t('message.ReturnIndex.totalPayment')}}:</div>
                                                                    <div class="col-2 flex-end" v-text="n(entry.invoice.totalPayment)"></div>
                                                                </div> -->
                                                                <div class="row detail-prd-row flex-end mt-4 pr-4">
                                                                    <button type="button" class="btn btn-save mx-1" @click="sendZalo(entry)">
                                                                        <i class="fa fa-share"></i>
                                                                        {{ $t('message.PurchaseOrderIndex.button.sendZalo') }}
                                                                    </button>
                                                                    <AppPermission :permission="this.$permissions.returns.create?? '' ">
                                                                        <button type="button" class="btn btn-save mx-1" @click.stop="returns(entry)"
                                                                        v-if="!entry.return && entry.statusOrigin == this.$constant.refund_approve">
                                                                            <i class="fa fa-reply-all"></i>
                                                                            {{$t('message.InvoiceIndex.button.return')}} 
                                                                        </button>
                                                                    </AppPermission>
                                                                    <AppPermission :permission="this.$permissions.refunds.update?? '' ">
                                                                        <button type="button" class="btn btn-save mx-1" @click="approveRefund(entry, 'update')"
                                                                            v-if="entry.statusOrigin == this.$constant.refund_status_origin" >
                                                                            <i class="fa fa-share"></i>
                                                                            {{ $t('message.CouponIndex.button.update') }}
                                                                        </button>
                                                                    </AppPermission>                                                                  
                                                                     <AppPermission :permission="this.$permissions.refunds.approve?? '' ">
                                                                        <button type="button" class="btn btn-save mx-1" @click="approveRefund(entry, 'approve')"
                                                                            v-if="entry.statusOrigin == this.$constant.refund_status_origin" >
                                                                            <i class="fa fa-reply-all"></i>
                                                                            {{ $t('message.HistoryIndex.button.process') }}
                                                                        </button>
                                                                    </AppPermission>
                                                                     <AppPermission :permission="this.$permissions.refunds.update?? '' ">
                                                                        <button type="button" class="btn btn-save mx-1" @click="quickSave(entry)">
                                                                            <i class="fa fa-save"></i>
                                                                            {{$t('message.button.save')}}
                                                                        </button>                                                            
                                                                    </AppPermission>        
                                                                        <button type="button" class="btn btn-secondary text-white mx-1" @click.stop="getTemplatePrint(entry)">
                                                                            <i class="fa fa-print" aria-hidden="true"></i>
                                                                            {{ $t('message.HistoryIndex.button.print') }} 
                                                                        </button>
                                                                    <AppPermission :permission="this.$permissions.refunds.export?? '' ">
                                                                        <button type="button" class="btn btn-secondary text-white mx-1" @click.stop="exportDetail(entry.id)">
                                                                            <i class="fa fa-file-export" aria-hidden="true"></i>
                                                                            {{ $t('message.HistoryIndex.button.export') }}
                                                                        </button>
                                                                    </AppPermission>
                                                                    <AppPermission :permission="this.$permissions.refunds.cancel?? '' ">
                                                                        <button type="button" class="btn btn-danger mx-1" 
                                                                            v-if="entry.statusOrigin == this.$constant.refund_status_origin || entry.statusOrigin == this.$constant.refund_approve" 
                                                                            @click="showModalConfirm(entry.id, entry.code)">
                                                                            <i class="fa fa-times"></i>
                                                                            {{ $t('message.HistoryIndex.button.cancel') }}
                                                                        </button>
                                                                    </AppPermission>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="detail-row bg-white border__footer-detail" v-if="requestRefundActive === entry.id"></tr>
                                                </template>
                                            </template>
                                            <template v-if="entries.length == 0 && !this.loading">
                                                <tr>
                                                    <td :colspan="fields.length + 1" class="pb-0 bg-light">
                                                        <div class="row detail-prd-row mx-0">
                                                            <div class="col-12 text-center text-secondary mt-5">
                                                                <h3>
                                                                    <i class="fa fa-file mr-2 text-secondary"></i>
                                                                    <i class="fa fa-exclamation"></i>
                                                                </h3>
                                                            </div>
                                                            <div class="col-12 text-center my-10 text-secondary mb-5">
                                                                <!-- <p>{{$t('message.common.notFound')}}</p> -->
                                                                <p>{{ !this.isFilter ? $t('message.common.notData') :  $t('message.common.notFound')}}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalSelectPrintTemplate ref="ModalSelectPrintTemplate" @updateContent="updateContent"/>
        <ModalAddInfoSaleChannels ref="ModalAddInfoSaleChannels" @updateContent="updateContent"/>
        <OrderPrint ref="OrderPrint" :editorDataClone="this.editorDataClone"/>
        <ModalRefundsCancel ref="ModalRefundsCancel" @updateContent="reloadData" />
        <ModalSelectSendMailAndZaloTemplate ref="ModalSelectSendMailAndZaloTemplate"/>
        <ModalCheckSettingReturnTime ref="ModalCheckSettingReturnTime"/>
        <ModalSelectSendZaloGroupTemplate ref='ModalSelectSendZaloGroupTemplate' />
    </AppPermission>
</template>
<script>
    import {$alert, $get, $post, clone, setArray, getSearchQuery, explode, removeVietnameseTones} from "@/lib/utils";
    import Pagination from "@/components/Pagination";
    import http from '@/services/api';
    import TableSortField from "@/components/TableSortField";
    import CreateReturn from "@/views/returns/CreateReturn";
    import emitter from "@/lib/emitter";
    import store from "../../store";
    import SelectSearch from "@/components/SelectSearch.vue";
    import SelectDateTime from "@/components/SelectDateTime.vue";
    import InputQuickSearch from "@/components/forms/InputQuickSearch.vue";
    import InputSelectSearch from "@/components/forms/InputSelectSearch.vue";
    import router from "@/router/index";
    import ModalAddInfoSaleChannels from "@/components/sale_channels/ModalAddInfoSaleChannels";
    import SelectField from "../../components/SelectField";
    import printTransactionMixin from "@/printTransactionMixin";
    import ModalSelectPrintTemplate from '@/components/ModalSelectPrintTemplate';
    import OrderPrint from '../orders/OrderPrint';    
    import AppPermission from '@/components/AppPermission.vue';    
    import ModalRefundsCancel from './tabs/ModalRefundsCancel.vue';
    import ModalSelectSendMailAndZaloTemplate from '@/components/ModalSelectSendMailAndZaloTemplate.vue';
    import ModalCheckSettingReturnTime from '@/components/returns/ModalCheckSettingReturnTime.vue';
    import ModalSelectSendZaloGroupTemplate from '@/components/ModalSelectSendZaloGroupTemplate.vue';
    import { mapGetters } from "vuex";
    import QSelect from "@/components/QSelect";
    import exportMixin from '@/exportMixin';
    export default {
        name: "RequestRefundIndex",
        mixins: [printTransactionMixin, exportMixin],
        components: {
            CreateReturn, 
            TableSortField, 
            Pagination, 
            SelectSearch, 
            SelectDateTime, 
            InputQuickSearch, 
            InputSelectSearch, 
            ModalAddInfoSaleChannels, 
            SelectField,
            ModalSelectPrintTemplate,
            OrderPrint,AppPermission,
            ModalRefundsCancel,
            ModalSelectSendMailAndZaloTemplate,
            ModalCheckSettingReturnTime,
            ModalSelectSendZaloGroupTemplate,
            QSelect
        },
        mounted() {
            document.title = this.$t('message.headers.request_refund') + ' | OmiPos';
            const fields = localStorage.getItem('requestRefundsSelectedFields_' + this.user.id);
            if (fields) {
                this.fields = JSON.parse(fields);
            }
            const query = clone(this.$route.query);
            if(query['code'] != null){
                this.filterQuery['request_refund_code'] = query['code'];
                this.loadDetail();
            }else{
                this.clearFilter();
            }
        },
        data() {
            const query = getSearchQuery();            
            const globalConfig = store.state.GlobalConfig;
            return {
                exEntries:[],
                filter: {
                    product_code_name: '',
                    code_name_phone: '',
                    note: '',
                    note_product: '',
                    delivery_code: '',
                    returns_code: '',
                    code_invoice: '',
                    request_refund_code: '',
                },
                checkedAll: false,
                fields: [],
                entries: [],
                sortData: {
                    field: 'id',
                    direction: 'desc',
                },
                paginate: {
                    currentPage: parseInt(query.page) || 1,
                    lastPage: 1
                },
                user: store.state.Auth ? store.state.Auth.user : {},
                numberRecord: 15,
                filterQuery: {
                    status: [],
                    type: [],
                    branchId: [],
                    createdBy: '',
                    receiverBy: '',
                    saleChannel: '',
                    paymentMethod: '',
                    priceList: '',
                },
                currentBranchId: store.state.CurrentBranch.id,
                branches: {
                    filter: globalConfig.branches,
                    all: globalConfig.branches,
                    search: null,
                },
                receiverBy: {
                    filter: globalConfig.users,
                    all: globalConfig.users,
                    search: null,
                },
                createdBy: {
                    filter: globalConfig.users,
                    all: globalConfig.users,
                    search: null,
                },
                priceLists: [],
                saleChannel: {
                    filter: globalConfig.saleChannels,
                    all: globalConfig.saleChannels,
                    search: null,
                },
                users: globalConfig.users,
                arrayChecked: [],
                loading: false,
                requestRefundActive: null,
                paginateDetail: {
                    currentPage: 1,
                    lastPage: 1,
                    totalRecord: 1,
                },
                defaultReturn:{
                    filter: null,
                    all: null,
                    searchCode: '',
                    searchName: '',
                },
                fieldRefundDetail : [],
                listStatus: [],
                listTypeReturn: [],
                receiverByEdit: null,
                headerActive: null,
                statusEditId: null,
                isFilter: false,
            }
        },
        methods: {
            async sendMailAndZalo() {
                this.$refs.ModalSelectSendMailAndZaloTemplate.show(this.$constant.TabRefunds, this.$constant.typeSellProducts, this.arrayChecked);
            },
            async sendZalo (entry = null) {
                if (entry) {
                    this.arrayChecked = [entry.id];
                }
                const typeSend = entry ? this.$constant.typeSendZaloZNS : this.$constant.typeSendZaloGroup;
                const phone = entry && entry.invoice && entry.invoice.customer ? (entry.invoice.customer.contactNumber ?? entry.invoice.customer.contactNumber1) : null;
                this.$refs.ModalSelectSendZaloGroupTemplate.show(this.$constant.TabRefunds, this.$constant.typeSellProducts, this.arrayChecked, typeSend, phone, true);
            },
            reloadData(){
                this.load();
            },
            createRefund(){
                var router = this.$router.resolve({
                    path: '/request_refund',
                    query: {
                        'type': 'create',
                        'code': null,
                    }
                });
                window.open(router.href, '_blank');
                //  window.open(router.href);
            },
            approveRefund(entry, type){                    
                this.$router.push({
                    path: '/request_refund',
                    query: {
                        'type': type,
                        'id': entry.invoiceId?? null,
                        'code': entry.invoiceCode?? null,
                        'refundId': entry.id?? null,
                        'refundCode': entry.code?? null,                        
                    }
                });                
                // window.open(router.href);
            },
            returns(entry){
                this.$refs.ModalCheckSettingReturnTime.show(entry, this.$constant.settingReturnTimeTypeRefund);
                // router.push({ name: 'CreateOrder', query: { returnRefunds: code}});
            },
            showModalConfirm(id, code){
                 this.$refs.ModalRefundsCancel.show(id, code);
            },
            showModalAddInfoSaleChannels(){
                this.$refs.ModalAddInfoSaleChannels.show();
            },
            async printMultiple(ids = null) {
                this.editorDataClone = '';
                const res = await $post('/v1/returns/data', {
                    ids: ids ?? this.arrayChecked,
                });
                if (res.result && res.result.length) {
                    await this.getTemplatePrint(res.result);
                }
            },
            async print(entry) { 
                entry.typePrint = this.$constant.TypePrintRefund;
                let dataPrint = this.dataPrint(entry);                
                this.editorDataClone = await this.renderData(dataPrint);
                this.$refs.OrderPrint.multiplePrint(this.editorDataClone);   
            },
            async getTemplatePrint(entry) {  
                const res = await $get(`/v1/print-templates/get-content-print-cli`,{action: 'TabRefunds'});                   
                if(res && res.status.code == 200){
                    if(res.result) {                    
                        this.$refs.ModalSelectPrintTemplate.show(res.result, entry);
                    }
                }  
            },
            async updateContent(data){                
                this.content = data.content;
                if (data.dataPrint && Array.isArray(data.dataPrint) ) {                    
                    await this.startPrintMultiple(data.dataPrint);
                } else {                    
                    await this.print(data.dataPrint);          
                }           
            },
            async startPrintMultiple(returns) { 
                let breakPage = `<div style="page-break-before: always"></div>`
                for (let index = 0; index < returns.length; index++) {
                    let order = returns[index];
                    order.typePrint = this.$constant.TypePrintRefund;
                    let dataPrint = await this.dataPrint(order);
                    let orderItem = await this.renderData(dataPrint);
                    if (index != returns.length -1 ) {
                        this.editorDataClone = this.editorDataClone + orderItem + breakPage;
                    } else {
                        this.editorDataClone = this.editorDataClone + orderItem;
                    }
                }
                this.$refs.OrderPrint.multiplePrint(this.editorDataClone); 
            },

            async clearFilter() {
                await this.$router.replace({
                    path: '/request-refund/index',
                    query: {}
                });

                Object.keys(this.filter).forEach(key => {
                    this.filter[key] = '';
                });
                Object.keys(this.filterQuery).forEach(key => {
                    if(key == 'type'){
                        this.filterQuery[key] = [0];
                    }else if(key == 'export'){
                        this.filterQuery[key] = false;
                    }else if(key == 'status'){
                        this.filterQuery[key] = [1, 2, 3, 4];
                    }else{
                        this.filterQuery[key] = '';
                    }
                });
                await emitter.emit("clearQuickSearch");
                await emitter.emit("clearSelectSearchValue");
                await emitter.emit("clearSelectDateTime");
                this.arrayChecked = [];
                this.numberRecord = 15;
                this.filterQuery.branchId = [this.currentBranchId];
                this.requestRefundActive = null;
                this.isFilter = false;
                await this.load();
            },
            getCheckedIDs() {
                return this.entries.filter(e => e.checked).map(e => e.id);
            },
            showHide(name,iDown, iUp){
                var dropdownContent = document.getElementById(name);
                dropdownContent.classList.toggle("dp-hide");
                var down = document.getElementById(iDown);
                down.classList.toggle("dp-hide");
                var up = document.getElementById(iUp);
                up.classList.toggle("dp-hide");
            },
            showCombo(entry){
                if(!entry.showCombo){
                    entry.showCombo = true;
                }else{
                    entry.showCombo = !entry.showCombo;
                }
            },
            isExistInArrayChecked(entry, array = []){
                if(array.includes(entry.id)){
                    entry.checked = true;
                    return true;
                }else{
                    entry.checked = false;
                    return false;
                }
            },
            countChecked(id){
                let arr = this.arrayChecked;
                if(arr.includes(id)){
                    arr = arr.filter(item => item !== id)
                }else{
                    arr.push(id)
                }
                this.arrayChecked = arr;
                this.isCheckedAll();
            },
            isCheckedAll(){
                let getChecked = 0;
                this.entries.forEach((entry) => {
                    const found = this.arrayChecked.find(id => id === entry.id);
                    if(found){
                        getChecked += 1;
                        entry.checked = true;
                    }
                });

                if(getChecked > 0 && getChecked == this.entries.length){
                    this.checkedAll = true;
                }else{
                    this.checkedAll = false;
                }
            },
            removeChecked(){
                this.arrayChecked = [];
                this.isCheckedAll();
            },
            onCheckedAll(value) {
                setArray(this.entries, {
                    checked: value
                });
                if(value == true){
                    this.entries.forEach(entry => {
                        const found = this.arrayChecked.find(id => id === entry.id);
                        if(!found){
                            this.countChecked(entry.id);
                        }
                    })
                }else{
                    this.entries.forEach(entry => {
                        this.countChecked(entry.id);
                    })
                }
            },
            onMouseLeave(){
                emitter.emit("mouseleave");
            },
            doFilterSearch(v){
                const query = clone(this.filterQuery);
                delete query[v.label];
                if(v.model){
                    query[v.label] = v.model;
                }
                query['page'] = 1;
                this.filterQuery = {...query};
                this.isFilter = true;
                this.load();
            },
            doFilterTime(v){
                const query = clone(this.filterQuery);
                delete query[v.label];
                if(v.value){
                    query[v.label] = v.value;
                }
                query['page'] = 1;
                this.filterQuery = {...query};
                this.isFilter = true;
                this.load();
            },
            detailRefund(id, entry){
                if (id === this.requestRefundActive) {
                    this.requestRefundActive = null;
                } else {
                    this.requestRefundActive = id;
                }
                if(entry && entry.statusOrigin){
                    this.statusEditId = entry.statusOrigin;
                }
                this.headerActive = 'info';
                this.defaultReturn.filter = this.defaultReturn.all = entry.details;
                this.setPaginate();
            },
            setPaginate(){
                this.paginateDetail.currentPage = 1;
                this.paginateDetail.lastPage = Math.ceil(this.defaultReturn.filter.length / 10);
                this.paginateDetail.totalRecord = this.defaultReturn.filter.length;
            },
            async doFilter(field, value) {
                const query = clone(this.filterQuery);
                if(field == 'status'){
                    if(query['status'].includes(value)){
                        query['status'] = query['status'].filter(item => item !== value)
                    }else{
                        query['status'].push(value)
                    }
                }else if(field == 'type'){
                    if(query['type'].includes(value)){
                        query['type'] = query['type'].filter(item => item !== value)
                    }else{
                        query['type'].push(value)
                    }
                }else{
                    query[field] = value;
                }
                query['page'] = 1;
                this.isFilter = true;
                this.filterQuery = {...query};
                await this.load();
            },
            async pageChange(page) {
                const query = clone(this.filterQuery);
                query['page'] = page;
                this.filterQuery = {...query};
                this.isFilter = true;
                await this.load();
            },
            async load() {
                this.loading = true;
                emitter.emit("onLoading");
                const res = await $post('/v1/refunds/data', {...this.$route.query, ...this.filterQuery, record: this.numberRecord});                
                if (res.result.code !== 200) {
                    $alert(res);
                    return;
                }

                if (!this.fields || !this.fields.length) {
                    this.fields = res.result.data.fields;
                }
                this.entries = res.result.data.data.data;       
                this.paginate.totalRecord = res.result.data.data.total;
                this.paginate.currentPage = res.result.data.data.current_page;
                this.paginate.lastPage = res.result.data.data.last_page;
                if (res.result.data.listStatus) {
                    this.listStatus = res.result.data.listStatus;
                }
                if (res.result.data.listFieldDetail) {
                    this.fieldRefundDetail = res.result.data.listFieldDetail;
                }
                this.isCheckedAll();
                emitter.emit("offLoading");
                this.loading = false;
            },
            async loadDetail(){
                await emitter.emit("clearQuickSearch");
                await emitter.emit("clearSelectSearchValue");
                await emitter.emit("clearSelectDateTime");
                this.arrayChecked = [];
                this.numberRecord = 15;
                this.filterQuery.branchId = [this.currentBranchId];
                this.requestRefundActive = null;
                await this.load();
                this.entries.forEach((entry) => {
                    this.detailRefund(entry.id, entry);
                });
            },
            isShow(){
                let isShow = false;
                this.fields.forEach(field => {
                    if(field.selected){
                        isShow = true;
                    }
                });
                return isShow;
            },
            async onChange(v) {
                this.numberRecord = v.target.value
                let query = clone(this.filterQuery);
                query['page'] = 1;
                this.filterQuery = {...query};
                this.isFilter = true;
                await this.load();
            },
            async changeQuickSearch(object){
                const query = clone(this.filterQuery);
                Object.keys(this.filter).forEach(key => {
                    object.forEach(obj => {
                        Object.keys(obj).forEach(o => {
                            if(key == o && obj[o] != ''){
                                this.filter[key] = obj[o];
                                query[o] = obj[o];
                            }else if(key == o && obj[o] == ''){
                                delete query[o];
                            }
                        });
                    })
                });
                query['page'] = 1;
                this.isFilter = true;
                this.filterQuery = {...query};
                this.load();
            },
            showContent(name) {
                this.headerActive = name;
            },
            setReceiverBy(receivedById){
                this.receiverByEdit = receivedById;
            },
            changeStatus(v){
                this.entries.forEach(entry => {
                    if(('status_' + entry.id) == v.label){
                        this.statusEditId = v.model;
                    }
                })
            },
            async quickSave(entry){
                const res = await $post('/v1/refunds/quick-save', {
                    id: entry.id, 
                    status: this.statusEditId,
                    description: entry.description
                });
                if(res.result.status == true){
                    $alert({
                        code: 200,
                        message: this.$t('message.common.updateRequestRefundSuccess', {code: entry.code}),
                    });
                    this.load();
                }else{
                    $alert({
                        code: 403,
                        message: this.$t('message.common.updateRequestRefundFailed', {code: entry.code}),
                    });
                }
            },
            async exSelectOverview() {                    
                let id = this.arrayChecked;  
                // let getBranchId = document.getElementById('branchDropdown');
                // let branchId = getBranchId.getAttribute('data-id'); 
                let branchId = store.state.CurrentBranch.id;                                
                const res = await http.download('/v1/returns/export-overview', { fields: this.fields, id: id, branch: branchId });
                const fileName = res.headers['content-disposition'].split('filename=')[1];
                var _blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(_blob);
                link.setAttribute('download', fileName);
                link.click();        
            },  
            async exSelectDetails() {
                let id = this.arrayChecked;
                // let getBranchId = document.getElementById('branchDropdown');
                // let branchId = getBranchId.getAttribute('data-id'); 
                let branchId = store.state.CurrentBranch.id;           
                const result = await http.download('/v1/refunds/export-detail', { fields: this.fields, id: id, branch: branchId });
                const fileName = result.headers['content-disposition'].split('filename=')[1];
                var _blob = new Blob([result.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(_blob);
                link.setAttribute('download', fileName);
                link.click();       
            },
            getOSByID(entries) {                
                let id = [];
                entries.forEach(item => {
                    id.push(item.id);
                });
                return id;
            },
            async dataExport(){
                const response = await $post('/v1/refunds/ex-data', {...this.$route.query, ...this.filterQuery, record: this.numberRecord});                
                if(response && response.status.code == 200 && response.result.code == 200 ){                    
                    this.exEntries = response.result.data.data;                    
                }        
            },
            async exportOverview() {
                //Get data
                emitter.emit("onLoading");
                const res = await http.download('/v1/refunds/export-overview', { 
                    fields: this.fields, 
                    // id: id,
                    ...this.filterQuery
                });                
                this.returnDataExport(res);
            },
            async exportDetail(id) {
                emitter.emit("onLoading");
                const result = await http.download('/v1/refunds/export-detail', { fields: this.fields, id: id });
                this.returnDataExport(result);
            },
            async exportRecord(id) {
                emitter.emit("onLoading");
                const res = await http.download('/v1/returns/export-record/' + id, { ...this.fields });
                this.returnDataExport(res);
            },
           
            async createReturns(){
                await this.$router.replace({
                    path: '/sale/create-order',
                    query: {
                        type: 'Return',
                    }
                });
            },
            onInputFilterReturnDetail(field){
                this.paginateDetail.currentPage = 1;
                if(this.defaultReturn.searchCode.length == 0 && this.defaultReturn.searchName.length == 0){
                    this.defaultReturn.filter = this.defaultReturn.all;
                    this.setPaginate();
                    return;
                }
                let arr = [];
                switch (field) {
                    case 'searchCode':
                        for (let index = 0; index < this.defaultReturn.all.length; index++) {
                            if (this.defaultReturn.all[index] != null && removeVietnameseTones(this.defaultReturn.all[index].product?.code.toLowerCase()).indexOf(removeVietnameseTones(this.defaultReturn.searchCode.toLowerCase())) > -1){
                                arr.push(this.defaultReturn.all[index]);
                            }
                        }
                        break;
                    case 'searchName':
                        for (let index = 0; index < this.defaultReturn.all.length; index++) {
                            if (this.defaultReturn.all[index] != null && removeVietnameseTones(this.defaultReturn.all[index].product?.name.toLowerCase()).indexOf(removeVietnameseTones(this.defaultReturn.searchName.toLowerCase())) > -1){
                                arr.push(this.defaultReturn.all[index]);
                            }
                        }
                        break;
                }
                this.defaultReturn.filter = arr;
                this.setPaginate();
            },
            async updateFilterBranch(values) {
                this.filterQuery.branchId = [...values];
                this.filterQuery.page = 1;
                this.isFilter = true;
                await this.load();
            }
        },
        computed: {
            ...mapGetters({
                statusEmail: 'settingStore/email',
            }),
        },
    }
</script>
<style scoped>
#number_records {
  margin-top: 11px;
}
.container input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.text-title {
  line-height: 52px;
}

#typeCard {
  margin-top: -8px;
}
#noteRO {
    border-left: 1px solid #ccc;
}
.noteStyle {
    width: 100% !important;
    height: 120px !important;
    border: 0;
    border-radius: 0;
}
.noteStyle:focus {
    outline: none !important;
    border-color: none;
    box-shadow: 0 none;
}
#fa_edit {
    position: absolute;
    left:20px;
    top:4px;
    color:#a7a2a2;
}
</style>